import { useBookingExpiry } from '@/contexts/BookingExpiryContext';
import { formatCountdown } from '@/utils/dateTime';
import { Icons } from '@fleet/webshop-ui';
import type React from 'react';

function BookingExpirationTimer(): React.ReactElement {
  const { countdown } = useBookingExpiry();

  return (
    <div className="flex h-8 w-20 items-center justify-start gap-1 rounded-md bg-white p-2 text-primary">
      <Icons.shoppingCart />
      {formatCountdown(countdown)}
    </div>
  );
}

export default BookingExpirationTimer;
